module.exports = __webpack_public_path__ + "static/media/moto_2.8ec65ffa.png";